import { render, staticRenderFns } from "./TenantMailServerManager.vue?vue&type=template&id=2a85e802&scoped=true&"
import script from "./TenantMailServerManager.vue?vue&type=script&lang=js&"
export * from "./TenantMailServerManager.vue?vue&type=script&lang=js&"
import style0 from "./TenantMailServerManager.vue?vue&type=style&index=0&id=2a85e802&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a85e802",
  null
  
)

export default component.exports